import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import BrandedTextOptions from "%/dynamic-components/render-engine/bundles/branded-text-options";
import TextOptions from "%/dynamic-components/render-engine/bundles/text-options";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import {
  TextElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/text-element/text-element-mixin";
import BasicTextOptions from "%/dynamic-components/render-engine/bundles/basic-text-options";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import AnimationOptions from "%/dynamic-components/render-engine/bundles/animations-options";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import BorderOptions from "%/dynamic-components/render-engine/bundles/border-options";
import ClickAction from "%/dynamic-components/render-engine/options/click-actions/click-action";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";
import TypographyBranding from "%/dynamic-components/render-engine/classes/branding/typography-branding";

export const BrandedTextElementMixin = {
  mixins: [DynamicElementMixin, TextElementMixin],
  brandingType: TypographyBranding,
  optionBundles: [
    AppearanceOptions,
    AnimationOptions,
    AnimationEffectsOptions,
    new LayoutWidthHeightOptions({}, {
      "max-height": true,
      "min-height": true,
    }),
    BrandedTextOptions,
    BasicTextOptions,
    TextOptions,
    new BackgroundOptions({}, {
      "background-image": true,
      "background-gradient": true,
    }),
    SpacingOptions,
    EffectsOptions,
    BorderOptions,
  ],
  options: [
    ClickAction,
  ],
  computed: {
    isEditable() {
      return true;
    },
    value() {
      return "";
    },
    shouldShowText() {
      return true;
    },
  },
  methods: {
    setDefaultBrandingValue() {
      // override text element mixin method to avoid adding text branding store
    },
  },
};
